/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Empty_SetsInputs */

const en_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please create a new set to start`)
};

const fr_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez creer un nouvel ensemble pour commencer`)
};

const de_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte erstellen Sie ein neues Set, um zu beginnen.`)
};

const it_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per iniziare, crea un nuovo set`)
};

const ru_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, создайте новый набор для начала.`)
};

const es_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor crea un nuevo conjunto para comenzar`)
};

const zh_cn2_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请创建一个新数据集以开始`)
};

const ja_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始するには新しいセットを作成してください`)
};

const hi_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया शुरुआत करने के लिए एक नया सेट बनाएं।`)
};

const pt_pt2_tags_manager_empty_sets = /** @type {(inputs: Tags_Manager_Empty_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, crie um novo conjunto para começar.`)
};

/**
* | output |
* | --- |
* | "Please create a new set to start" |
*
* @param {Tags_Manager_Empty_SetsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_empty_sets = /** @type {((inputs?: Tags_Manager_Empty_SetsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Empty_SetsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_empty_sets(inputs)
	if (locale === "de") return de_tags_manager_empty_sets(inputs)
	if (locale === "it") return it_tags_manager_empty_sets(inputs)
	if (locale === "ru") return ru_tags_manager_empty_sets(inputs)
	if (locale === "es") return es_tags_manager_empty_sets(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_empty_sets(inputs)
	if (locale === "ja") return ja_tags_manager_empty_sets(inputs)
	if (locale === "hi") return hi_tags_manager_empty_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_empty_sets(inputs)
	return en_tags_manager_empty_sets(inputs)
});